import { type MutationError, trpc } from '@/shared/api';

interface UseCreatePrintMethodOptions {
  readonly onSuccess?: () => void;
}

/** 인쇄 방식 추가. */
export const useCreatePrintMethod = ({ onSuccess }: UseCreatePrintMethodOptions = {}) => {
  const mutation = trpc.productManagement.printMethods.create.useMutation({ onSuccess });

  const error: MutationError | null = mutation.error;

  return {
    createPrintMethod: mutation.mutate,
    isPending: mutation.isPending,
    error,
  };
};
